import { Colors } from "@blueprintjs/core";
import styled from "styled-components";
import { Box } from "ui-components";
const TableComponent = styled(Box)<{ bgColor?: string; minHeight?: string }>`
  padding: 5px 20px 0px 0px;
  // border-radius: 12px;
  // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  // background-color: ${({ theme: { darkMode }, bgColor }) =>
    bgColor ? bgColor : darkMode ? Colors.DARK_GRAY5 : Colors.WHITE};
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.WHITE : Colors.DARK_GRAY5};
  min-height: ${({ minHeight }) => (minHeight ? minHeight : "fit-content")};
`;

export default TableComponent;
